<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('user-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit User Form -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveUser">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>
                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-text-field :label="$t('first-name')"
                                          v-model="user.fstName"
                                          v-validate="'max:15'"
                                          :data-vv-as="$t('first-name')"
                                          :error-messages="errors.collect('firstname')"
                                          name="firstname"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-text-field :label="$t('second-name')"
                                          v-model="user.secName"
                                          v-validate="'max:15'"
                                          :data-vv-as="$t('second-name')"
                                          :error-messages="errors.collect('secondname')"
                                          name="secondname"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-text-field :label="$t('third-name')"
                                          v-model="user.thirdName"
                                          v-validate="'max:15'"
                                          :data-vv-as="$t('third-name')"
                                          :error-messages="errors.collect('thirdname')"
                                          name="thirdname"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-text-field :label="$t('family-name')"
                                          v-model="user.familyName"
                                          v-validate="'max:15'"
                                          :data-vv-as="$t('family-name')"
                                          :error-messages="errors.collect('familyname')"
                                          name="familyname"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('ar-full-name')"
                                          v-model="user.arFullName"
                                          v-validate="'max:100'"
                                          :data-vv-as="$t('ar-full-name')"
                                          :error-messages="errors.collect('arFullName')"
                                          name="arFullName"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('en-full-name')"
                                          v-model="user.enFullName"
                                          v-validate="'max:100'"
                                          :data-vv-as="$t('en-full-name')"
                                          :error-messages="errors.collect('enFullName')"
                                          name="enFullName"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-select :label="$t('select-gender')"
                                      v-model="user.gender"
                                      :data-vv-as="$t('gender')"
                                      :error-messages="errors.collect('gender')"
                                      :items="genders"
                                      name="gender">
                                <template slot="selection" slot-scope="data">
                                    {{ $t(data.item.text) }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    {{ $t(data.item.text) }}
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12  >
                            <v-autocomplete :data-vv-as="$t('nationality') + ' *'"
                                            :error-messages="errors.collect('nationalityLookUpCode')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="nationalityList"
                                            :label="$t('nationality')"
                                            :name="'nationalityLookUpCode'"
                                            clearable
                                            item-value="code"
                                            v-model="user.nationalityLookUpCode"></v-autocomplete>
                        </v-flex>
                        <!--<v-flex md4 sm6 xs12>
                            <v-menu ref="menu"
                                    v-model="datepicker1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    clearable
                                    full-width
                                    min-width="290px">
                                <v-text-field slot="activator"
                                              class="mr-2"
                                              v-model="user.bod"
                                              :label="$t('birth-of-date')"
                                              prepend-icon="event"
                                              readonly
                                              :data-vv-as="$t('birth-of-date')"
                                              :error-messages="errors.collect('bod')"
                                              name="bod"></v-text-field>
                                <v-date-picker ref="picker"
                                               v-model="user.bod"
                                               min="1900-01-01"
                                               :max="new Date().toISOString().substr(0, 10)"
                                               @change="datepicker1 = false"></v-date-picker>
                            </v-menu>
                        </v-flex>-->
                        <!--<v-flex md4 sm6 xs12 v-if=" fieldsSecurity.userName.isShow">-->
                        <!--: disabled="!fieldsSecurity.userName.isEnable"-->
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('user-name')"
                                          v-model="user.userName"
                                          v-validate="'required|max:50'"
                                          :data-vv-as="$t('user-name')"
                                          :error-messages="errors.collect('userName')"
                                          name="userName"></v-text-field>
                        </v-flex>

                        <!--v-if="!mode && fieldsSecurity.password.isShow"
                        :disabled="!fieldsSecurity.password.isEnable"-->
                        <v-flex md4 sm6 xs12 v-if="!this.$route.params.id">
                            <v-text-field type="Password"
                                          browser-autocomplete="off"
                                          :label="$t('password')"
                                          v-model="user.password"
                                          v-validate="!this.$route.params.id ? 'required|min:6' : ''"
                                          :data-vv-as="$t('password')"
                                          :error-messages="errors.collect('password')"
                                          name="password"
                                          ref="password"></v-text-field>
                        </v-flex>
                        <!--v-if="!mode && fieldsSecurity.password.isShow"
                        :disabled="!fieldsSecurity.password.isEnable"-->
                        <v-flex md4 sm6 xs12 v-if="!this.$route.params.id">
                            <v-text-field type="Password"
                                          :label="$t('confirm-password')"
                                          v-model="user.confirmPassword"
                                          v-validate="!this.$route.params.id ? 'required|min:6|confirmed:password' : ''"
                                          :data-vv-as="$t('confirm-password')"
                                          :error-messages="errors.collect('confirmPassword')"
                                          name="confirmPassword"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('email') + ' *'"
                                          v-model="user.email"
                                          v-validate="'required|email|max:50'"
                                          :data-vv-as="$t('email')"
                                          :error-messages="errors.collect('email')"
                                          name="email"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('mobile')  + ' *'"
                                          v-model="user.mobile"
                                          v-validate="'numeric|max:15'"
                                          :data-vv-as="$t('mobile')"
                                          :error-messages="errors.collect('mobile')"
                                          name="mobile"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-textarea solo
                                        :label="$t('address')"
                                        v-model="user.address"
                                        v-validate="'max:100'"
                                        :data-vv-as="$t('address')"
                                        :error-messages="errors.collect('address')"
                                        name="address"></v-textarea>
                        </v-flex>
                        <v-flex mb-2 md3 px-2 sm6 xs12  >
                            <v-text-field :data-vv-as="$t('national-number')"
                                          :error-messages="errors.collect('nationalIDNum')"
                                          :label="$t('national-number')"
                                          :name="'nationalIDNum'"
                                          v-model="user.nationalIDNum"
                                          v-validate="'numeric'"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-select :label="$t('select-source')"
                                      v-model="user.source"
                                      :data-vv-as="$t('source')"
                                      :error-messages="errors.collect('source')"
                                      :items="sources"
                                      readonly
                                      name="source"></v-select>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('governorate')"
                                            :error-messages="errors.collect('governorateCode')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="governoratesList"
                                            :label="$t('governorate') "
                                            clearable
                                            item-value="code"
                                            name="governorateCode"
                                            v-model="user.governorate"
                                            @change="GetCities($event)"></v-autocomplete>
                        </v-flex>
                        <v-flex md4 px-2 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('city')"
                                            :error-messages="errors.collect('cityCode')"
                                            :item-text="getLabelByLang('name', 'name')"
                                            :items="citiesList"
                                            :label="$t('city')"
                                            clearable
                                            item-value="id"
                                            name="cityCode"
                                            v-model="user.city"></v-autocomplete>
                        </v-flex>

                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-text-field :label="$t('userIntegration')"
                                          v-model="user.userIntegrationId"
                                          v-validate="'max:50'"
                                          :data-vv-as="$t('userIntegration')"
                                          :error-messages="errors.collect('userIntegrationId')"
                                          readonly
                                          name="userIntegrationId"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-menu ref="menu"
                                    v-model="datepicker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    clearable
                                    min-width="290px">
                                <v-text-field slot="activator"
                                              class="mr-2"
                                              v-model="user.expiryDate"
                                              :label="$t('expiry-Date')"
                                              prepend-icon="event"
                                              readonly
                                              :data-vv-as="$t('expiry-Date')"
                                              :error-messages="errors.collect('expiryDate')"
                                              name="expiryDate"></v-text-field>
                                <v-date-picker ref="picker"
                                               v-model="user.expiryDate"
                                               min="1900-01-01"
                                               :max="new Date().toISOString().substr(0, 10)"
                                               @change="datepicker = false"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex md4 sm6 xs12 v-if="false">
                            <v-autocomplete :label="$t('directManager')"
                                            v-model="user.directManager"
                                            :items="userList"
                                            name="directManager"
                                            :item-text="getLabelByLang('arFullName', 'enFullName')"
                                            item-value="id"
                                            clearable
                                            :disabled="isDialog"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('save') }}</v-btn>
                            <v-btn color="primary" :to="{ name: 'user' }">{{ $t('cancel') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-form>
    </v-layout>
</template>

<script>
    import LookUpService from '@/services/LookUpService';
    import UserService from '@/services/UserService';
    import { mapGetters } from 'vuex';

    const CREATE = 0;
    const UPDATE = 1;

    export default {
        name: 'user-details',
        data() {
            return {
                selected: [],
                // Filters
                user: {
                    id: 0,
                    gender: 1,
                    fstName: null,
                    secName: null,
                    thirdName: null,
                    familyName: null,
                    enFullName: null,
                    arFullName: null,
                    bod: null,
                    userName: null,
                    password: '',
                    confirmPassword: '',
                    email: null,
                    mobile: null,
                    source: 1,
                    address: null,
                    expiryDate: null,
                    nationalIDNum: null,
                    governorate: null,
                    city: '',
                    nationalityLookUpCode: null,
                    userIntegrationId: null,
                    directManager: null,
                },
                props: { // For parent list "����� �� ��� ������"  , "For directManager" properity
                    isDialog: { type: Boolean },
                    userItem: { type: Object },
                },

                datepicker: false,
                datepicker1: false,
                mode: CREATE,
                fieldsSecurity: {
                    password: { isShow: false, isEnable: false },
                    userName: { isShow: false, isEnable: false }
                },
                userList: [], //For parent list "����� �� ��� ������"  , "For directManager" properity
                nationalityList: [],
                genders: [{ value: 1, text: 'male' }, { value: 2, text: 'female' }],
                sources: [{ value: 1, text: 'admin Web' }, { value: 2, text: 'LDAP' }, { value: 3, text: 'Mobile' }, { value: 4, text: 'Guest' }, { value: 5, text: 'User Integration' }, { value: 6, text: 'User AutoLogin' }],
                governoratesList: [],
                citiesList: [],
            };

        },
        async created() {
            /*For Call other Enteties*/
            await this.getNationalityList();
            await this.getGovernorates();
            await this.getCities();
            await this.getUser(); // For parent list "����� �� ��� ������"  , "For directManager" properity

            const fs = this.permissions.pages[this.$route.meta.code].fields;
            if (fs.length) {
                this.fieldsSecurity = {
                    password: fs.find(field => field.name === 'password'),
                    userName: fs.find(field => field.name === 'userName')
                };
            }

            const userId = this.$route.params.id;
            if (userId) {
                /* add loading in edit mode */
                this.$store.dispatch('showLoading');
                const user = (await UserService.getUser(userId)).data;
                if (user.expiryDate) user.expiryDate = user.expiryDate.substr(0, 10);
                if (user.bod) user.bod = user.bod.substr(0, 10);
                this.$store.dispatch('hideLoading');
                if (!user) this.$router.push({ name: 'user' });
                this.user = { ...this.user, ...user };
                this.mode = UPDATE;
            }
        },

        methods: {
            /* save Operation */
            async saveUser() {
                const isValid = await this.$validator.validateAll();
                // alert(isValid);
                if (isValid) {
                    /* add loading on save */
                    this.$store.dispatch('showLoading');
                    const result = await UserService.saveUser(this.user);
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch('showMessage', { text: result.data.message });
                        this.$router.push({ name: 'user' });
                    } else {
                        this.$store.dispatch('showMessage', { text: result.data.message, color: 'error' });
                        //this.$router.push({ name: 'user', color: 'error' });
                    }
                    this.$store.dispatch('hideLoading');
                }
            },

            /*Get operations*/

            async getUser() { //For parent list "����� �� ��� ������"  , "For directManager" properity
                this.userList = (await UserService.getUsers()).data;
            },
            async GetCities(code) {
                this.citiesList = (await LookUpService.GetCities(code)).data;
            },
            async getNationalityList() {
                this.nationalityList = (await LookUpService.getLookup(39)).data;
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getCities() {
                this.citiesList = (await LookUpService.getLookup(100)).data;
            }
        },
        computed: {
            ...mapGetters(['permissions'])
        },
        watch: {
            datepicker(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
            }
        }
    };
</script>
